<template>
    <div id="enCert" class="flex align-cen"  ref="imageWrapper" :class=" propId ? 'temClass' : ''">
        <div class="enCert-bg">
            <div class="certBox-item-title">
                      {{list.title}}
              </div>
            <div class="certBox-item-content flex align-cen">
                        <div class="certBox-item-content-1">
                               {{list.content}}
                        </div>
                        <div class="certBox-item-content-2">
                            <img 
                             :src="`${picurl}?${new Date().getTime()}`"
                                alt="" 
                                crossOrigin="anonymous"
                                >
                            <div class="certBox-item-content-2-name">
                               {{list.recipientName}}
                            </div>
                        </div>
                    </div>
                    <div class="certBox-item-info">
                         <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">身份证号:</div>
                                <div class="top-val">
                                    {{list.idNo}}
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                                ID Number
                            </div>
                        </div>
                          <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">证书编号:</div>
                                <div class="top-val">
                                    {{list.certificateNo}}
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                                Certificate Number
                            </div>
                        </div>
                           <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">发证机构:</div>
                                <div class="top-val top-val1">
                                    （盖章）
                                    <img 
                                    :src="`${list.institutionSignet}?${new Date().getTime()}`"
                                     alt="" 
                                     crossOrigin="anonymous"
                                    class="top-val-img">
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                               Issuing Authority (Seal)
                            </div>
                        </div>
                           <div class="flex" >  
                             <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">发证日期:</div>
                                <div class="top-val">
                                    {{list.issueTime}}
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                              Date of Issue
                            </div>
                        </div>
                          <!-- <div class="certBox-item-info-item" style="margin-left:70px">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">发证机构负责人(签章):</div>
                                <div class="top-val2">
                                     <img 
                                      :src="`${list.principalSignet}?${new Date().getTime()}`"
                                      alt="" 
                                      crossOrigin="anonymous" 
                                     alt="" class="top-val-img1">
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                             Person in Charge of Issuing Authority
                            </div>
                        </div> -->
                        </div>
                            <div class="certBox-item-info-item">
                            <div class="certBox-item-info-item-top flex ">
                                <div class="top-label">查询网址:</div>
                                <div class="top-val top-val1 top-val3 flex align-cen">
                                     <vue-canvas-poster :widthPixels="70" :painting="painting" @success="success" @fail="fail"></vue-canvas-poster>
                                     <div class="urldsiv">
                                        <!-- {{this.$config.prUrl + '#/webenterprise/enCert?id='+ seeId}}  -->
                                     </div>
                                </div>
                            </div>
                            <div class="certBox-item-info-item-bot">
                               Website
                            </div>
                        </div>
                    </div>
        </div>
    </div>
</template>
<script>
import {getReceive} from "@/api/index/index"  //查询领取人详情
import html2canvas from "html2canvas";
export default {
     props: {
    propId: [String, Number], //是否为组件调用 
    arrType:[String, Number]
    },
    data() {
        return {
            seeId:'',
            picurl:'',
            list:{},
            posterImg:'',
            painting: {
                    width: '70px',
                    height: '70px',
                    borderRadius:'0px',
                    views: [
                         {
                        type: 'qrcode',
                        content: '',
                        css: {
                            top: '0px',
                            left: '0px',
                            color: '#000',
                            width: '70px',
                            height: '70px'
                        }
                        },
                    ],
                },  
        }
    },
    created () {
         if(!this.$util.isMobile()){
            this.getCertDetail()
        }else{
            this.$router.replace({
                name:'mobileIndex',
                query:{
                    id:this.$route.query.certId
                }
            })
        }
    },
    methods: {
        // 下载
       //下载图片
            downimg() {
        const clientWidth = this.$refs.imageWrapper.offsetWidth;
      const clientHeight = this.$refs.imageWrapper.offsetHeight;
      const kh = [clientWidth, clientHeight];

      html2canvas(this.$refs.imageWrapper, { useCORS: true, logging: true }).then((canvas) => {
        const dataURL = canvas.toDataURL('image/png');
        this.download(dataURL, kh);
      });
    },
     getUrlBase64(url, kh) {
      return new Promise((resolve) => {
        let canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();
        img.crossOrigin = 'Anonymous'; // 允许跨域
        img.src = url;
        img.onload = () => {
          // eslint-disable-next-line prefer-destructuring
          canvas.height = kh[1];
          // eslint-disable-next-line prefer-destructuring
          canvas.width = kh[0];
          ctx.drawImage(img, 0, 0, kh[0], kh[1]);
          const dataURL = canvas.toDataURL('image/png');
          canvas = null;
          resolve(dataURL);
        };
      });
    },
    download(imgUrl, kh) {
      this.getUrlBase64(imgUrl, kh).then((base64) => {
        const link = document.createElement('a');
        link.href = base64;
        link.download = `${this.list.recipientName}-${this.list.title}证书.jpg`;
        link.click();
            this.$emit('sendStatus2', false)
         if(!this.arrType) this.$util.Notifi('下载成功','success','fa-check')
      });
    },
         success(src) {
             this.posterImg = src;
            },
            fail(err) {
                console.log('fail', err)
            },
         // 证书详情
        getCertDetail(){
            let id = this.$route.query.certId ? this.$route.query.certId : this.propId;
             getReceive({id:id},'get')
            .then(res =>{
               this.list = res.data
               this.picurl = res.data.pic
               this.seeId = res.data.id
               this.painting.views[0].content = this.$config.prUrl + '#/webenterprise/mobileIndex?id='+ res.data.id
               document.title = `${res.data.recipientName}-${res.data.title}`
                if(this.propId) {
                  setTimeout(() => {
                 this.downimg()
                })
                }
            })
            .catch(err =>{})
        }, 
    },
}
</script>
<style lang="scss" scoped>
.temClass{
    position: absolute;
    z-index: -999;
    left: -999px;
    top: -999px;
}
#enCert{
    overflow: auto;
    justify-content: center;
    height: 100vh;
    .enCert-bg{
       width:1069px;
        height: 803px;
        background: url("../../assets/images/certImg.jpg") no-repeat 0 0;
        background-size: 100% 100%;
        overflow: hidden;
        .certBox-item-title{
           text-align: center;
            font-size: 43px;
            padding-top: 133px;
            font-weight: bold;
            color: #000;
        }
         .certBox-item-content{
               padding: 0 154px;
               height: 170px;
                .certBox-item-content-1{
                    width: 624px;
                    font-size: 20px;
                    line-height: 30.3px;
                    color: #000;
                    text-indent:45px;
                    margin-right: 29.8px;
                     display: -webkit-box;  
                    -webkit-line-clamp: 4;  
                    -webkit-box-orient: vertical;  
                    overflow: hidden;  
                    text-overflow: ellipsis; 
                }
                .certBox-item-content-2{
                    width: 109px;
                    height: 145px;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                    .certBox-item-content-2-name{

                        font-size: 20px;
                        color: #000;
                        line-height: 30px;
                        letter-spacing: 5px;
                        text-align: center;
                        padding-top: 10px;

                        
                    }
                }
            }
                      .certBox-item-info{
               padding-left: 183px;
            .certBox-item-info-item{
                .certBox-item-info-item-top{
                    .top-label{
                         letter-spacing: 10px;
                        line-height: 30px;
                        color: #000000;
                        font-size: 18px;
                    }
                     .top-val{
                        width: 200px;
                        text-align: center;
                        font-size: 18px;
                        line-height: 30px;
                        color: #000000;
                        border-bottom: 2px solid #000;
                        position: relative;
                        .top-val-img{
                            width: 140px;
                            height: 140px;
                            border-radius: 50%;
                            position: absolute;
                            right: -50px; 
                            z-index: 999;
                        }
                       
                    }
                   .top-val2{
                        position: relative;
                          width: 100px;
                            height: 30px;
                         .top-val-img1{
                            width: 100px;
                            height: 30px;
                            position: absolute;
                        }
                    }
                    .top-val1{
                        border-bottom: none;
                        text-align: left;
                    }
                    .top-val3{
                        width: auto;
                        padding-left: 80px;
                        font-size: 13px;
                        position: relative;
                        .urldsiv{
                          position: absolute;
                            width: 600px;
                            top: 15px;
                        }
                    }
                }
                .certBox-item-info-item-bot{
                      font-size: 16px;
                    line-height: 30px;
                    font-style: italic;
                }
            }
            }
    }
}
::v-deep{
    .canvas{
        position: absolute !important;
        left: 0vw;
        top: -1.5vh;
    }
   @media (max-width: 640px) {
        .el-main[data-v-bcc96446] {
        padding-top: 0 !important;
    }
} 
}
</style>